import { withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from 'react-redux';
import { toggleNavInverse } from '../../store/actions';
import Logo from './DistilledIdLogo';
import LogoDark from './DistilledIdLogoDark';
import './NavMenu.css';

class NavMenu extends Component {

  renderLogo() {
    if (window.innerWidth < 1000) {
      return (<Logo height={14} />);
    }
    if (this.props.navInverse && window.innerWidth >= 1000) {
      return (<Logo height={14} />);
    }
    if (!this.props.navInverse && window.innerWidth >= 1000) {
      return (<LogoDark height={14} />);
    }
  }

  render() {
    return (
      <Navbar
        inverse={this.props.navInverse}
        collapseOnSelect
      >
        <Navbar.Header >
          <Navbar.Brand>
            <LinkContainer eventkey={1} to="/home" >
              <div
                onClick={
                  !this.props.navInverse ? this.props.toggleNavInverse : null
                }
              >{this.renderLogo()}
              </div>
            </LinkContainer>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header >
        <Navbar.Collapse >
          <Nav >
            {/* <NavDropdown
              eventKey={2}
              title="Discover"
              id="basic-nav-dropdown"
              className="nav-dropdown"
              onClick={() => this.props.toggleNavInverse()}
            >
              <Col md={3}>
                <MenuItem eventKey={2.1} className="nav-item">
                  <ul>
                    <li>Distillery Management Platform</li>
                    <span>Manage every aspect of your distillery from the arrival of stock</span>
                  </ul>
                </MenuItem>
              </Col>
              <Col md={3}>
                <MenuItem eventKey={2.2} className="nav-item">
                  <ul>
                    <li>Unique Storybook</li>
                    <span>
                      Deliver direct consumer interaction regarding taste,
                      heritage, sustainability
                    </span>
                  </ul>
                </MenuItem>
              </Col>

              <Col md={3}>
                <MenuItem eventKey={2.3} className="nav-item">
                  <ul>
                    <li>Consumer Intelligence</li>
                    <span>
                      Consumer & product data available through the platform analytics engine
                    </span>
                  </ul>
                </MenuItem>
              </Col>
            </NavDropdown> */}

            <LinkContainer
              eventKey={3} to="/home" exact
              onClick={
                !this.props.navInverse ? this.props.toggleNavInverse : null
              }
            >
              <NavItem>
                Discover
              </NavItem>
            </LinkContainer>

            <LinkContainer
              eventKey={3} to="/case_studies" exact
              onClick={
                !this.props.navInverse ? this.props.toggleNavInverse : null
              }
            >
              <NavItem>
                Case Studies
              </NavItem>
            </LinkContainer>
            <LinkContainer
              eventKey={4} to="/about"
              onClick={
                !this.props.navInverse ? this.props.toggleNavInverse : null
              }
            >
              <NavItem>
                About
              </NavItem>
            </LinkContainer>
            <LinkContainer eventKey={5} to="/news"
              onClick={
                !this.props.navInverse ? this.props.toggleNavInverse : null
              }
            >
              <NavItem>
                News
              </NavItem>
            </LinkContainer>
            <LinkContainer eventKey={5} to="/contact"
              onClick={
                !this.props.navInverse ? this.props.toggleNavInverse : null
              }
            >
              <NavItem>
                Contact
              </NavItem>
            </LinkContainer>
          </Nav>
        </Navbar.Collapse>

      </Navbar>

    );
  }
}

const mapStateToProps = state => ({
  navInverse: state.navInverse,
  navOpaque: state.navOpaque,
});

const mapDispatchToProps = dispatch => ({
  toggleNavInverse: () => {
    dispatch(toggleNavInverse());
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavMenu));




// WEBPACK FOOTER //
// ./src/components/common/NavMenu.js